import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RentalReconciliationScreen from './screens/RentalReconciliationScreen';

function RentalReconciliations() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RentalReconciliationScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RentalReconciliations;
